import { memo } from "react";
import { View, Text } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";

type NoClipPlaceholderProps = {
  screenWidth: number;
  screenHeight: number;
  hourRangeLabel: string;
};

export const NoClipPlaceholder = memo(({ screenWidth, screenHeight, hourRangeLabel }: NoClipPlaceholderProps) => {
  const { theme } = useUnistyles();

  return (
    <>
      <View mb="3xl" mt="lg">
        <Text textStyle="xs/semibold">{hourRangeLabel}</Text>
      </View>
      <View
        style={[
          styles.container,
          {
            width: screenWidth - theme.spacing.lg * 2,
            maxHeight: screenHeight * 0.4,
          },
        ]}
        alignItems="center"
        justifyContent="center"
      >
        <View mb="lg">
          <Icon name="eventOutline" color={theme.colors.text} />
        </View>
        <View mb="lg">
          <Text textStyle="md/semibold">No clips</Text>
        </View>
        <View>
          <Text textStyle="xs/regular">No clips found during this time.</Text>
        </View>
      </View>
    </>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    aspectRatio: 16 / 9,
    alignSelf: "center",
    borderRadius: theme.spacing.md,
    backgroundColor: "#64748B14",
  },
}));
